export function Modals() {

  const modalOpenBtns = document.querySelectorAll('[data-modal-open]');
  const modalCloseBtns = document.querySelectorAll('[data-modal-close]');
  const body = document.querySelector('body');

  if (modalOpenBtns.length) {
    modalOpenBtns.forEach(modalBtn => {
      modalBtn.addEventListener('click', function(evt) {
        evt.preventDefault();
        if (typeof modalBtn.dataset.modalOpen !== 'undefined') {
          const modalId = modalBtn.dataset.modalTarget;
          const modal = document.getElementById(modalId);
          if (modal) {
            modal.classList.add('modal--visible');
            body.classList.add('modal--open');
          }
        }
      });
    });
  }

  if (modalCloseBtns.length) {
    modalCloseBtns.forEach(modalBtn => {
      modalBtn.addEventListener('click', function(evt) {
        evt.preventDefault();
        modalBtn.parentNode.classList.remove('modal--visible');
        body.classList.remove('modal--open');
      });
    });
  }
}
